<div class="table-cover">
  <div class="flex items-center">
    <div class="grow flex flex-wrap justify-between items-center mt-3 {{ tableConfigurations.showSearch ? 'border' : '' }} rounded-xl bg-transparent">
      <!-- <div *ngIf="tableConfigurations.showSearch"
           class="search-container grow {{showExportButton ? 'border-r mr-4' : ''}}">
        <mat-icon class="text-gray">search</mat-icon>
        <input
          #input
          (keydown)="_handleKeydown($event)"
          (keyup)="_handleKeyup($event)"
          [(ngModel)]="searchQuery"
          class="input" placeholder="Search..." type="text">
        <button
          (click)="search()"
          @fadeIn
          [disabled]="searchQuery.length === 0"
          class="flex bg-secondary items-center gap-1 mr-2">
          <svg aria-labelledby="search" fill="none" height="16" role="img" width="17" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.667 12.667A5.333 5.333 0 107.667 2a5.333 5.333 0 000 10.667zM14.334 14l-2.9-2.9"
                  stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"></path>
          </svg>
          {{ 'Search' | concat | translate }}
        </button>
      </div> -->

      <!--    <div class="border-r flex flex-col mx-3 px-1">-->
      <!--      <mat-divider class="mx-3 !h-full" [vertical]="true"></mat-divider>-->
      <!--    </div>-->

      <!--      *ngIf="!tableConfigurations.hideExport && exportGraph && !tableLoading"-->

      <button (click)="downloadToCsv()"
              *ngIf="showExportButton"
              class="!bg-white" color="primary" mat-stroked-button>
        <mat-icon svgIcon="excel"></mat-icon>
        {{ 'Export' | concat | translate }}
      </button>
    </div>

    <div
      *ngIf="showDateRange"
      class="ms-3 me-1 mt-3 mb-1 border-b rounded overflow-hidden"
    >
      <div class="border border-b-0 mb-[-16px] rounded">
        <mat-form-field appearance="fill">
          <mat-label>Enter a Date Range</mat-label>
          <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Start Date" [readonly]="true">
            <input matEndDate formControlName="end" placeholder="End Date" [readonly]="true">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>
  </div>

  <app-loader
    *ngIf="loadingExportData"
    @fadeIn
    message="Preparing Export Data"
  ></app-loader>
  <app-loader
    *ngIf="tableLoading && !tableList?.length"
    @fadeIn
    message="{{ loadingMessage || 'Please Wait...' }}"
  ></app-loader>

  <div
    class="{{
      tableConfigurations.actionIcons.checkBox
        ? 'mat-elevation-z2'
        : 'mat-elevation-z2'
    }} p-0 overflow-x-scroll"
  >

    <table
      [dataSource]="dataSource"
      [trackBy]="trackByFn"
      class="{{
        tableConfigurations.actionIcons.checkBox
          ? 'default-table'
          : 'default-table'
      }}"
      mat-table
      matSort
    >
      <!-- Number Column -->
      <ng-container matColumnDef="position">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>No</th>
        <td
          *matCellDef="let element; let i = index"
          [ngClass]="{
            active: tableConfigurations.active[element?.id],
            error: element?.hasError,
            success: element?.hasSuccess
          }"
          class="ms-3"
          mat-cell
        >
          {{ i + 1 }}
        </td>
      </ng-container>

      <!-- Position Column -->
      <ng-container
        *ngFor="let column of tableConfigurations.tableColumns"
        matColumnDef="{{ column.name }}"
      >
        <th *matHeaderCellDef class="" mat-header-cell mat-sort-header scope="col">
          {{ column.label }}
          <mat-icon *ngIf="column && column.info" [matTooltip]="column.info"
          >info_outline
          </mat-icon
          >
        </th>
        <td
          (click)="tdClick(column, element[column.name])"
          *matCellDef="let element"
          [ngClass]="{
            active: tableConfigurations.active[element?.id],
            error: element?.hasError,
            success: element?.hasSuccess
          }"
          [ngStyle]="{ alias: column.link }"
          [ngStyle]="{
            backgroundColor:
              column.type == 'color' ? element[column.name]?.color : '',
            'text-align': column.align ? column.align : '',
            'padding-right': '5px'
          }"
          [title]="element?.tableToolTip || ''"
          mat-cell
          style="max-width: 250px"
        >
          <span *ngIf="column && column.type == 'svgIcon'">
            <mat-icon [svgIcon]="element[column.name]"></mat-icon>
          </span>
          <span *ngIf="column && column.type == 'date'">
            {{ element[column.name] | date : "mediumDate" }}
          </span>
          <span *ngIf="column && column.type == 'dateTime'">
            {{ element[column.name] | date : "medium" }}
          </span>
          <span *ngIf="column && column.type == 'image'">
            <img
              [src]="element[column.name]"
              alt="element[column?.name]"
              style="height: 60px; width: 60px"
            />
          </span>
          <span
            *ngIf="
              column &&
              column.type != 'date' &&
              column.type != 'dateTime' &&
              column.type != 'number' &&
              column.type != 'svgIcon' &&
              column.type != 'image'
            "
          >
            <ng-container *ngIf="column && column.case == 'titlecase'">
              {{ element[column.name] | titlecase }}
            </ng-container>
            <ng-container *ngIf="column && column.case == 'uppercase'">
              {{ element[column.name] | uppercase }}
            </ng-container>
            <ng-container *ngIf="column && column.case == 'lowercase'">
              {{ element[column.name] | lowercase }}
            </ng-container>
            <ng-container
              *ngIf="
                column &&
                column.case != 'lowercase' &&
                column.case != 'uppercase' &&
                column.case != 'titlecase'
              "
            >
              <span [innerHtml]="element[column.name]"></span>
            </ng-container>
          </span>
        </td>
      </ng-container>

      <!--Action Icons-->
      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell scope="col">
          <div
            *ngIf="tableConfigurations.actionIcons.checkBox"
            class="flex justify-end"
          >
            <mat-checkbox
              (change)="onSelectAll($event)"
              [aria-label]="checkboxLabel()"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              class="text-right"
            >
            </mat-checkbox>
          </div>
        </th>
        <td
          *matCellDef="let tableListItem"
          [ngClass]="{
            active: tableConfigurations.active[tableListItem?.id],
            error: tableListItem?.hasError,
            success: tableListItem?.hasSuccess
          }"
          mat-cell
        >
          <div
            *ngIf="
              tableConfigurations.actionIcons.edit ||
              tableConfigurations.actionIcons.print ||
              tableConfigurations.actionIcons.delete ||
              tableConfigurations.actionIcons.more ||
              tableConfigurations.actionIcons.cancel ||
              tableConfigurations.actionIcons.download ||
              tableConfigurations.actionIcons.customPrimary ||
              tableConfigurations.actionIcons.checkBox || (actionButtons || []).length > 0
            "
            aria-label="Basic example"
            class="float-right"
            role="group"
          >
            <ng-container *ngIf="!userTypes?.['customPrimary'] || (userTypes?.['customPrimary']?.indexOf(userType) > -1)">
              <ng-container *ngxPermissionsOnly="permissions?.customPrimary">
                <button
                  (click)="customPrimaryItem(tableListItem)"
                  *ngIf="
                    tableConfigurations?.actionIcons?.customPrimary &&
                    !showDelete[tableListItem?.id] &&
                    (tableListItem | showButton : 'customPrimary')
                  "
                  class="cursor btn-sm"
                  mat-raised-button
                  style="
                    color: white;
                    background-color: #025590;
                    padding: 0 10px !important;
                    font-size: 14px;
                    border-radius: 5px !important;
                    margin-right: 5px !important;
                  "
                  title="{{ tableConfigurations.customPrimaryMessage }}"
                >
                  {{
                    tableListItem.customPrimaryMessage
                      ? tableListItem.customPrimaryMessage
                      : tableConfigurations.customPrimaryMessage
                  }}
                </button>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="tableConfigurations.actionIcons.checkBox">
              <mat-checkbox
                (change)="onCheckboxClick($event, tableListItem)"
                (click)="$event.stopPropagation()"
                [aria-label]="checkboxLabel(tableListItem)"
                [checked]="
                  selectedCheckboxTracker[tableListItem?.id]
                    ? selectedCheckboxTracker[tableListItem?.id]
                    : false
                "
              >
              </mat-checkbox>
            </ng-container>

            <button
              (click)="printItem(tableListItem?.id)"
              *ngIf="
                tableConfigurations?.actionIcons?.print &&
                !showDelete[tableListItem?.id]
              "
              mat-icon-button
              style="border-radius: 50%"
              title="print"
            >
              <mat-icon>print</mat-icon>
            </button>

            <ng-container *ngIf="!userTypes?.['more'] || (userTypes?.['more']?.indexOf(userType) > -1)">
              <ng-container *ngxPermissionsOnly="permissions?.more">
                <a
                  (click)="viewItemDetails(tableListItem)"
                  *ngIf="
                    tableConfigurations?.actionIcons?.more &&
                    !showDelete[tableListItem?.id] &&
                    (tableListItem | showButton : 'more')
                  "
                  mat-icon-button
                  style="border-radius: 50%"
                  title="view details"
                >
                  <mat-icon svgIcon="s_view"></mat-icon>
                </a>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!userTypes?.['edit'] || (userTypes?.['edit']?.indexOf(userType) > -1)">
              <ng-container *ngxPermissionsOnly="permissions?.edit">
                <a
                  (click)="editItem(tableListItem)"
                  *ngIf="
                    tableConfigurations?.actionIcons?.edit &&
                    !showDelete[tableListItem?.id] &&
                    (tableListItem | showButton : 'edit')
                  "
                  mat-icon-button
                  style="color: #00405d; border-radius: 50%"
                  title="edit"
                >
                  <mat-icon svgIcon="edit"></mat-icon>
                </a>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!userTypes?.['download'] || (userTypes?.['download']?.indexOf(userType) > -1)">
              <ng-container *ngxPermissionsOnly="permissions?.download">
                <a
                  (click)="downloadItem(tableListItem)"
                  *ngIf="
                    tableConfigurations?.actionIcons?.download &&
                    !showDownload[tableListItem?.id]
                  "
                  mat-icon-button
                  style="border-radius: 50%"
                  title="Download"
                >
                  <mat-icon style="font-size: 16px">file_download</mat-icon>
                </a>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="!userTypes?.['delete'] || (userTypes?.['delete']?.indexOf(userType) > -1)">
              <ng-container *ngxPermissionsOnly="permissions?.delete">
                <a
                  (click)="showDelete[tableListItem?.id] = true"
                  *ngIf="
                    tableConfigurations?.actionIcons?.delete &&
                    !showDelete[tableListItem?.id] &&
                    (tableListItem | showButton : 'delete')
                  "
                  color="warn"
                  mat-icon-button
                  style="border-radius: 50%"
                  title="delete"
                >
                  <mat-icon style="font-size: 16px" svgIcon="trash_delete"
                  ></mat-icon
                  >
                </a>
              </ng-container>
            </ng-container>

            <!--extra menu items-->

            <div
              *ngIf="
                actionButtons.length != 0 &&
                (actionButtons | showOtherButtons : tableListItem)
              "
              [matMenuTriggerFor]="menuItem"
              class="example-button-container">
              <button
                color="none"
                mat-mini-fab
                style="elevation: 0 !important;"
                title="More Actions"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>
            <mat-menu #menuItem="matMenu">
              <ng-container *ngFor="let btn of actionButtons">
                <ng-container *ngIf="!userTypes?.[btn?.id] || (userTypes?.[btn?.id]?.indexOf(userType) > -1)">
                  <ng-container *ngxPermissionsOnly="permissions[btn.id]">
                    <button
                      (click)="submitCustomButtom(btn, tableListItem, 'first')"
                      *ngIf="tableListItem | showButton : btn.id"
                      [class]="btn.class"
                      [title]="btn.title"
                      mat-menu-item
                    >
                      <mat-icon
                        *ngIf="btn.icon && (btn?.iconType === 'MAT' || !btn?.iconType)"
                        [style.color]="btn?.textColor || 'black'"
                      >{{ btn.icon }}
                      </mat-icon
                      >
                      <mat-icon
                        *ngIf="btn.icon && btn?.iconType === 'SVG'"
                        [class]="btn?.classColor"
                        [style.color]="btn?.textColor"
                        [svgIcon]="btn.icon"
                      ></mat-icon
                      >
                      <img
                        *ngIf="btn.image"
                        [alt]="btn.title"
                        [src]="btn.image"
                        style="height: 20px"
                      />
                      {{ btn.label }}
                    </button>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-menu>

            <button
              (click)="showDelete[tableListItem?.id] = true"
              *ngIf="
                tableConfigurations?.actionIcons?.cancel &&
                !showDelete[tableListItem?.id]
              "
              mat-flat-button
              title="Cancel"
            >
              <mat-icon>cancel</mat-icon>
              Cancel
            </button>

            <!-- Confirmation message for additional button -->
            <ng-container *ngFor="let btn of actionButtons">
              <app-loader
                *ngIf="
                  tableConfigurations.loading &&
                  tableConfigurations.loading[btn.id + tableListItem.id]
                "
                [message]="btn.loading_message"
              ></app-loader>
              <p *ngIf="showButtonConfirm[btn.id + tableListItem?.id]">
                {{ btn.confirm_message }}
              </p>
              <p *ngIf="showButtonConfirm[btn.id + tableListItem?.id]">
                <button
                  (click)="submitCustomButtom(btn, tableListItem, 'last')"
                  *ngIf="
                    !(
                      tableConfigurations.loading &&
                      tableConfigurations.loading[btn.id + tableListItem.id]
                    )
                  "
                  class="cursor"
                  mat-mini-fab
                  style="
                    color: white !important;
                    background-color: green;
                    border-radius: 50% !important;
                    margin-right: 10px;
                    width: 25px !important;
                    height: 25px !important;
                  "
                >
                  <mat-icon style="color: white !important;"
                  >done
                  </mat-icon
                  >
                </button>
                <button
                  (click)="showButtonConfirm = {}"
                  *ngIf="
                    !(
                      tableConfigurations.loading &&
                      tableConfigurations.loading[btn.id + tableListItem.id]
                    )
                  "
                  class="cursor"
                  mat-mini-fab
                  style="
                    color: white !important;
                    background-color: red;
                    border-radius: 50% !important;
                    width: 25px !important;
                    height: 25px !important;
                  "
                >
                  <mat-icon style="color: white !important;"
                  >clear
                  </mat-icon
                  >
                </button>
              </p>
            </ng-container>
            <!-- ===================================================== -->

            <!--delete confirmation-->
            <div
              *ngIf="
                showDelete[tableListItem?.id] &&
                !tableConfigurations.deleting[tableListItem?.id]
              "
              @fadeIn
              style="margin-top: 2px; margin-bottom: 2px"
            >
              Are You sure?
            </div>
            <p
              *ngIf="
                showDelete[tableListItem?.id] &&
                tableConfigurations.deleting[tableListItem?.id]
              "
              @fadeIn
            >
              <span *ngIf="tableConfigurations?.actionIcons?.cancel"
              >Canceling</span
              >
              <span *ngIf="tableConfigurations?.actionIcons?.delete"
              >Deleting</span
              >
            </p>
            <div
              *ngIf="showDelete[tableListItem?.id]"
              @fadeIn
              style="display: flex; margin-bottom: 10px"
            >
              <mat-progress-bar
                *ngIf="tableConfigurations.deleting[tableListItem?.id]"
                @fadeIn
                mode="indeterminate"
              >
              </mat-progress-bar>
              <button
                (click)="deleteItem(tableListItem)"
                *ngIf="!tableConfigurations.deleting[tableListItem?.id]"
                @fadeIn
                mat-mini-fab
                matTooltip="Delete"
                style="
                  color: white !important;
                  background-color: green;
                  border-radius: 50% !important;
                  margin-right: 10px;
                "
              >
                <mat-icon style="color: white !important;"
                >done
                </mat-icon
                >
              </button>
              <button
                (click)="showDelete = {}"
                *ngIf="!tableConfigurations.deleting[tableListItem?.id]"
                @fadeIn
                mat-mini-fab
                style="
                  color: white !important;
                  background-color: red;
                  border-radius: 50% !important;
                "
              >
                <mat-icon style="color: white !important;"
                >clear
                </mat-icon
                >
              </button>
            </div>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr
        (click)="onRowClick(row)"
        *matRowDef="let row; columns: displayedColumns; let i = index"
        [ngClass]="routeAnimationsElements"
        class="card-1 move-up"
        mat-row
        style="--order: {{ i * 0.7 }}"
      ></tr>
    </table>
    <table class="w-full">
      <tr *ngIf="!dataSource.data.length">
        <td [colSpan]="displayedColumns.length-1" style="text-align: center;">
          <p *ngIf="!tableLoading" class="text-center text-base text-muted pt-2">
            {{ tableConfigurations.empty_msg || "No data" }}
          </p>
        </td>
      </tr>
    </table>
    <!--Pagination-->
    <mat-paginator
      (page)="onChangePage($event)"
      [length]="resultLength"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      showFirstLastButtons
    ></mat-paginator>
  </div>
  <!--  <div class="{{ tableConfigurations.actionIcons.checkBox ? 'mat-elevation-z2' : 'mat-elevation-z2' }}">

  </div>-->
</div>
